<div class="random-monster-card-container" #container>
  <div
    class="card vertical random-monster-card"
    [ngClass]="{ flipped: flipped(), fh: fh }"
    [style.fontSize]="container.offsetWidth * 0.05 + 'px'"
  >
    <div class="card-back random-monster-card-back"></div>
    <div class="card-front random-monster-card-front">
      <div class="name" [ghs-label]="'data.section.title.' + section.name"></div>
      <div class="index">{{ section.index }}</div>
      @if (element) {
        <div class="element">
          <img [src]="'./assets/images/' + (fh ? 'fh/' : '') + 'element/' + element + '.svg'" />
        </div>
      }
      <div class="slots">
        @for (i of [] | ghsRange: 12; track i) {
          <div class="slot-container">
            <label>{{ i + 1 }}</label>
            @if (monster[i]) {
              <div class="slot monster">
                <div class="image">
                  <div class="outer-border">
                    <div class="inner-border">
                      <div class="image-container">
                        <img [src]="gameManager.monsterManager.monsterThumbnail(monster[i])" />
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  class="type player2"
                  [ngClass]="{
                    normal: standees[i].type === 'normal' || standees[i].player2 === 'normal',
                    elite: standees[i].type === 'elite' || standees[i].player2 === 'elite'
                  }"
                >
                  <span class="inner-border"></span>
                </span>
                <span
                  class="type player3"
                  [ngClass]="{
                    normal: standees[i].type === 'normal' || standees[i].player3 === 'normal',
                    elite: standees[i].type === 'elite' || standees[i].player3 === 'elite'
                  }"
                >
                  <span class="inner-border"></span>
                </span>
                <span
                  class="type player4"
                  [ngClass]="{
                    normal: standees[i].type === 'normal' || standees[i].player4 === 'normal',
                    elite: standees[i].type === 'elite' || standees[i].player4 === 'elite'
                  }"
                >
                  <span class="inner-border"></span>
                </span>
              </div>
            }
            @if (overlays[i]) {
              <div class="slot overlay">
                <div
                  class="image"
                  [ngClass]="{
                    obstacle: overlays[i].type === 'obstacle',
                    'difficult-terrain': overlays[i].type === 'difficultTerrain',
                    'hazardous-terrain': overlays[i].type === 'hazardousTerrain',
                    trap: overlays[i].type === 'trap',
                    treasure: overlays[i].type === 'treasure',
                    loot: overlays[i].type === 'loot'
                  }"
                >
                  <div class="border">
                    <div class="image-container">
                      <img
                        [src]="
                          './assets/images/scenario/random/overlays/' +
                          (fh ? 'fh/' : '') +
                          (overlays[i].type === 'loot' || overlays[i].type === 'treasure' ? overlays[i].type : overlays[i].value) +
                          '.png'
                        "
                      />
                    </div>
                  </div>
                </div>
                @if (overlays[i].type === 'treasure' && overlays[i].value) {
                  <div class="value">
                    <span class="separator">:</span>
                    <span
                      class="values"
                      [ghs-label]="'scenario.random.treasure.' + overlays[i].value"
                      [ghs-label-args]="overlays[i].values || []"
                    ></span>
                  </div>
                }
                @if (overlays[i].type !== 'treasure' && overlays[i].values) {
                  <div class="value">
                    <span class="separator">:</span>
                    <span class="values">
                      @for (condition of overlays[i].values; track condition) {
                        <img [src]="'./assets/images/' + (fh ? 'fh/' : '') + 'condition/' + condition + '.svg'" />
                      }
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
